"use client";

import { useEffect, useMemo } from "react";
import { useToken } from "../../lib/context/auth-context";
import {
  getLoggedinUser,
} from "../../lib/util";
import { useCartCollections } from "../../lib/services/collection-service";
import { getActiveUser } from "../slice/auth-slice";
import { setCartsFromCollections } from "../slice/cart-slice";
import { useAppDispatch, useAppSelector } from "../slice/hooks";

export const useMarketplaceCartCollections = () => {
  const dispatch = useAppDispatch();
  const { token } = useToken();
  const { loggedInUser } = useAppSelector((state) =>
    getActiveUser(state, getLoggedinUser()),
  );

  const userId = loggedInUser?.user?.userId ?? null;
  const activeToken = userId ? loggedInUser?.token : token;

  const query = useCartCollections({
    userId,
    token: activeToken,
    cartSource: "MARKETPLACE",
    enabled: userId ? Boolean(userId) : true,
  });

  const collections = useMemo(() => {
    const fetchedCollections = query.data?.data?.collections;
    return Array.isArray(fetchedCollections) ? fetchedCollections : [];
  }, [query.data]);

  useEffect(() => {
    if (!query.isSuccess) return;
    dispatch(setCartsFromCollections(collections));
  }, [dispatch, collections, query.isSuccess]);

  return {
    ...query,
    collections,
    userId,
    userToken: loggedInUser?.token ?? null,
    guestToken: token,
  };
};
